<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-row lg="12">
          <v-col lg="12">
            <small
              ><b>Archivo:</b> {{ NombreDocumento }}
              <!-- {{ NombreDocumento + Formato }} --></small
            >
          </v-col>
          <v-col cols="6" lg="6" align-self="center">
            <v-btn
              color="red-darken-4"
              class="ma-2 white--text"
              @click="download"
            >
              Descargar Archivo<v-icon right dark> mdi-download </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="urldoc != null" justify="center" class="mt-5">
          <audio
            v-if="Formato == '.mp3' || Formato == '.wav'"
            crossorigin="anonymous"
            :src="
              'data:audio/' +
              (Formato == '.mp3' ? 'mp3' : 'wav') +
              ';base64,' +
              urldoc
            "
            style="max-width: 100%; min-width: 50%"
            controls
            preload="auto"
          ></audio>
          <iframe
            v-else-if="
              Formato == '.pdf' || Formato == '.PDF' || Formato == '.txt'
            "
            :src="
              'data:' +
              (Formato == '.pdf' || Formato == '.PDF'
                ? 'application/pdf'
                : Formato == '.txt'
                ? 'text/plain'
                : '') +
              ';base64,' +
              urldoc
            "
            style="width: 100%; height: 73vh"
            >El navegador nop soporta la vista previa, por favor de click
            <a
              :href="
                'data:' +
                (Formato == '.pdf' || Formato == '.PDF'
                  ? 'application/pdf'
                  : Formato == '.txt'
                  ? 'text/plain'
                  : '') +
                ';base64,' +
                urldoc
              "
            >
              <u> aquí para descargar el archivo</u>
            </a></iframe
          >
          <v-img
            v-else-if="
              Formato == '.jpeg' ||
              Formato == '.png' ||
              Formato == '.jpg' ||
              Formato == '.bmp'
            "
            max-height="700px"
            max-width="95%"
            :src="
              'data:image/' +
              (Formato == '.jpeg' || Formato == '.jpg'
                ? 'jpeg'
                : Formato == '.png'
                ? 'png'
                : '.bmp') +
              ';base64,' +
              urldoc
            "
            @click="AbrirImagen"
            contain
            style="cursor: pointer"
            alt="pulse para abrir en pantalla completa"
          ></v-img>
          <div
            style="width: 100%"
            ref="docContainer"
            v-else-if="Formato == '.docx' || Formato == '.doc'"
          ></div>
          <div
            style="width: 100%"
            v-else-if="Formato == '.xlsx' || Formato == '.ppt'"
          >
            <iframe
              :src="
                'https://docs.google.com/gview?url=' + urldoc + '&embedded=true'
              "
              frameborder="1"
              style="width: 100%; height: 610px"
            ></iframe>
            <br />
            Si no puede visualizar el documento, pulse
            <a :href="urldoc" target="_blank"><b>aquí</b></a
            >.
          </div>
          <span v-else
            >De en el botón descargar, debido a que el formato de archivo no se
            puede visualizar.</span
          >
        </v-row>
        <v-row v-else justify="center">
          <span>No Existe URL registrada</span>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { renderAsync } from "docx-preview";
export default {
  name: "Visor_Documentos",
  // LLamada de campos propos
  props: {
    LinkDocumento: {
      type: String,
      default: "",
    },
    NombreDocumento: {
      type: String,
      default: "",
    },
    TipoDocumemto: {
      type: String,
      default: "",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    Formato: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      urldoc: this.LinkDocumento,
    };
  },
  methods: {
    ////////////////////////////////////////////// FUNCIONES CRUD ////////////////////////////////////////////////////////////
    // Abrir Imagen
    AbrirImagen() {
      var win = window.open();
      win.document.write(
        '<img crossorigin="anonymous" src="data:image/' +
          (Formato == ".jpeg" || Formato == ".jpg" ? "jpeg" : "png") +
          ";base64," +
          this.urldoc +
          '"  style="max-width:100%; max-height:100%;"/>',
      );
    },

    // Método para descargar el Documento consultado
    download() {
      // Definir el tipo MIME y la extensión del archivo según el formato
      let mimeType;
      let extension;

      if (this.Formato == ".pdf" || this.Formato == ".PDF") {
        mimeType = "application/pdf";
        extension = ".pdf";
      } else if (this.Formato == ".txt" || this.Formato == ".TXT") {
        mimeType = "text/plain";
        extension = ".txt";
      } else if (
        this.Formato == ".jpeg" ||
        this.Formato == ".jpg" ||
        this.Formato == ".bmp" ||
        this.Formato == ".JPEG" ||
        this.Formato == ".JPG" ||
        this.Formato == ".BMP"
      ) {
        mimeType = "image/jpeg";
        extension = ".jpeg";
      } else if (this.Formato == ".png" || this.Formato == ".PNG") {
        mimeType = "image/png";
        extension = ".png";
      } else if (this.Formato == ".wav" || this.Formato == ".WAV") {
        mimeType = "audio/mav";
        extension = ".wav";
      } else if (this.Formato == ".mp3" || this.Formato == ".MP3") {
        mimeType = "audio/mp3";
        extension = ".mp3";
      } else if (this.Formato == ".zip" || this.Formato == ".ZIP") {
        mimeType = "application/zip";
        extension = ".zip";
      } else if (this.Formato == ".tar" || this.Formato == ".TAR") {
        mimeType = "application/x-tar";
        extension = ".tar";
      } else if (this.Formato == ".eml" || this.Formato == ".EML") {
        mimeType = "message/rfc822";
        extension = ".eml";
      } else if (this.Formato == ".msg" || this.Formato == ".MSG") {
        mimeType = "application/vnd.ms-outlook";
        extension = ".msg";
      } else if (this.Formato.toLowerCase() == ".docx") {
        console.log("Documentos");
        mimeType =
          "@file/vnd.openxmlformats-officedocument.wordprocessingml.document";
        extension = ".docx";
      }

      let archivoName = `archivo${extension}`;

      if (this.infollaves != null) {
        // Si hay información de llaves, se puede usar para el nombre del archivo
        if (
          this.infollaves.Contrato != null &&
          this.infollaves.Contrato != ""
        ) {
          // Si el contrato no es nulo o vacío, se usa para el nombre del archivo
          archivoName = `${
            this.infollaves.Contrato
          }_${this.TipoDocumemto.replaceAll(" ", "_").replaceAll(
            ".",
            "",
          )}${extension}`;
        }
      }

      // Crear un enlace de descarga para descargar el archivo
      const link = document.createElement("a");
      link.href = `data:${mimeType};base64,${this.urldoc}`;
      link.download = archivoName; // El nombre del archivo con la extensión
      link.click(); // Dispara la descarga

      // Abrir el archivo en una nueva pestaña
      //window.open(`data:${mimeType};base64,${this.urldoc}`, "_blank");
    },

    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      return new Blob([byteArray], {
        type: mimeType,
      });
    },

    async renderDoc() {
      const blob = this.base64ToBlob(
        this.urldoc,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      );

      await renderAsync(blob, this.$refs.docContainer);
    },
  },

  mounted() {
    if (this.Formato.toLowerCase() === ".docx") {
      this.renderDoc();
    }
  },
};
</script>
